import { connect } from 'react-redux';
import { participantCount, participants } from '@core/selectors/classroom';
import { getCurrentSpaceId } from '@core/selectors/space';
import { fetchClassRoomParticipants } from '@core/actions/classRoom/participants';
import CommonRoomResponsive from './CommonRoomResponsive';

const mapStateToProps = (state) => {
  const spaceId = getCurrentSpaceId(state);

  return {
    isFetchingParticipants: state.classRoom.isFetchingParticipants,
    participantTotal: participantCount(state),
    participants: participants(state, spaceId),
    spaceId,
  };
};

const mapDispatchToProps = (dispatch) => ({
  fetchParticipantsPreview: () =>
    dispatch(
      fetchClassRoomParticipants({ reset: true, skip: 0, sort: undefined })
    ),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CommonRoomResponsive);
